import { FormControl, MenuItem, Select } from "@mui/material";
import { BentoCategory, OrganizationNiche } from "schemas/dashboard";
import { CustomEvent } from "schemas/functions";

import styles from "../styles";

interface Props {
  categoriesToPickFrom: BentoCategory[];
  niche: OrganizationNiche;
  onChange: (e: CustomEvent) => void;
  nicheError?: boolean;
}

const PickerDropdown = ({
  categoriesToPickFrom,
  niche,
  onChange,
  nicheError = false,
}: Props) => {
  return (
    <FormControl fullWidth>
      <Select
        displayEmpty
        name="bentoCategoryId"
        sx={styles.textField}
        value={niche?.bentoCategoryId || ""}
        onChange={onChange}
        error={nicheError}
      >
        <MenuItem value="">
          <em>Pick Niche</em>
        </MenuItem>
        {categoriesToPickFrom.map((category) => (
          <MenuItem key={category.id} value={category.id}>
            {category.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default PickerDropdown;
